"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _de_DE = _interopRequireDefault(require("../../date-picker/locale/de_DE"));
var _default = _de_DE["default"];
exports["default"] = _default;